import React from "react";

import { Disclosure } from "@headlessui/react";
import { Caret } from "@routes/IconeSvg";

/**
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {any} props.children
 * @returns
 */
function DisclosureListbox({ label, children }) {
  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button className="arh-flex arh-w-full arh-items-center arh-justify-between arh-rounded arh-border-0 arh-bg-transparent arh-p-2  arh-font-poppins arh-text-xs arh-font-medium arh-text-black hover:arh-bg-gray-200 active:arh-bg-greyActive">
            <span>{label}</span>
            <Caret
              className={`${open ? "arh-rotate-90" : "arh-rotate-0"}`}
              aria-hidden="true"
            />
          </Disclosure.Button>
          <Disclosure.Panel className="arh-my-2">{children}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export default DisclosureListbox;
